import gql from 'graphql-tag';

export const GET_INDICATORS = gql`
query indicators($hav: String!) {
    indicators(hav: $hav)
}`;

/* istanbul ignore next */
export const queryOptions = ({hav}) => ({
    variables: {hav},
    notifyOnNetworkStatusChange: false,
    errorPolicy: 'all'
});

/**
 * Remove indicator from the cache
 * @param {ApolloClient} client
 */
export const removeIndicator = ({boardId, client, hav}) => {
    const variables = {hav};
    const cache = client.readQuery({query: GET_INDICATORS, variables});
    if (cache && Array.isArray(cache.indicators)) {
        cache.indicators = cache.indicators.filter((board) => board !== boardId);
        client.writeQuery({query: GET_INDICATORS, variables, data: cache});
    }
};


// WEBPACK FOOTER //
// ./src/universal/tripboard/activity-indicator/activity-indicator-graphql.js